import { getAPIUrl } from '../API'

export const requestEuaPropertyEnquiry = async (values: {
  officeCode: string
  schemeName: string
  schemeNumber: string
  exclusiveUsageNumber: string[]
}) => {
  let retryCount = 0

  while (retryCount < 3) {
    const response = await fetch(`${getAPIUrl()}/Deeds/EUAPropertyEnquiry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
      },
      body: JSON.stringify(values),
    })

    if (!response.ok) {
      const data = await response.json()
      console.log('Data in requestEuaPropertyEnquiry (error):', data)

      if (data.Message.includes('There was no endpoint listening')) {
        retryCount++
        console.log(`Retrying request. Retry count: ${retryCount}`)
      } else {
        return data.data
      }
    } else {
      const data = await response.json()
      console.log('Data in requestEuaPropertyEnquiry (success):', data)
      return data
    }
  }

  console.log('Exceeded maximum retries. Stopping.')
  return null
}

export type EuaQueryParams =
  | {
      cmaid: string
    }
  | {
      officeCode: string
      schemeName: string
      schemeNumber: string
    }

export const requestEuaQuery = async (values: EuaQueryParams) => {
  let retryCount = 0

  while (retryCount < 3) {
    const response = await fetch(`${getAPIUrl()}/Deeds/EUADeedsQueryLookup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
      },
      body: JSON.stringify(values),
    })

    if (!response.ok) {
      const data = await response.json()
      console.log('Data in requestEuaQuery (error):', data)
      if (data.Message.includes('There was no endpoint listening')) {
        retryCount++
        console.log(`Retrying request. Retry count: ${retryCount}`)
      } else {
        return data.data
      }
    } else {
      const data = await response.json()
      console.log('Data in requestEuaQuery (success):', data)
      return data
    }
  }
  console.log('Exceeded maximum retries. Stopping.')
  return null
}
